<template>
    <div
      class="mt-8">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.freeze"
            @keydown.esc="dialog.freeze = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Freeze Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div 
                          class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in configHeaders" 
                              :key="index"
                              class="px-0"
                              @click="item.freeze = !item.freeze ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  color="#718EBF"
                                  :input-value="item.freeze">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.freeze ? 'font-weight-bold' : ''"
                                  :style="item.freeze ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  color="#718EBF"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Freeze
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.hide"
            @keydown.esc="dialog.hide = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Hide Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.hide = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in headers" 
                              :key="index"
                              class="px-0"
                              @click="item.hide = !item.hide ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  color="#718EBF"
                                  :input-value="item.hide">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.hide ? 'font-weight-bold' : ''"
                                  :style="item.hide ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  color="#718EBF"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Hide
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.filter"
            @keydown.esc="dialog.filter = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Filter Data
                </div>
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.filter = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <v-select
                  filled
                  rounded
                  dense
  
                  color="#718EBF"
                  placeholder="Contoh. 2023"
  
                  hide-details
  
                  :items="years"
                  :item-color="set_color"
  
                  v-model="filter.year"
                  style="border-radius: 10px;">
                </v-select>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn 
                  @click="dialog.filter = false; fetch();"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Filter
                </v-btn>
  
                <v-btn 
                  @click="dialog.filter = false"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header">
                <div
                  class="fs-20 font-weight-bold">
                  Mengubah Status Customer
                </div>
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.form = false; reset();"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="py-3 my-2 px-0">
                
                
  
                <div v-if="message.error.length > 0"
                  class="text-center mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
              
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0">
                <v-spacer/>
  
                <v-btn 
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="150"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Simpan
                </v-btn>
  
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="120"
                  height="45"
                  elevation="0"
                  color="warning"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ditolak
                </v-btn>
  
                <!-- <v-btn 
                  @click="dialog.form = false; reset();"
                  :disabled="process.form"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog 
            v-if="dialog.confirm"
            v-model="dialog.confirm"
            @keydown.esc="dialog.confirm = false"
            width="800"
            persistent
            scrollable>
            <v-card class="border-radius-card">
              <v-card-title class="d-flex align-center pa-4 text-right popup-header">
                <div class="fs-20 font-weight-bold">
                  Konfirmasi Hapus Data
                </div>

                <v-spacer/>

                <v-icon 
                  @click="dialog.confirm = false"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <v-divider class="mb-2" style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text class="py-4 px-6">
                <!-- Teks konfirmasi -->
                <div class="mb-4">
                  <p class="body-1 mb-2">
                    Anda ingin menghapus bpb dengan data berikut:
                  </p>
                  
                  <!-- Data BPB yang akan dihapus -->
                  <div class="mb-4">
                    <div class="d-flex align-center mb-2">
                      <span class="font-weight-bold mr-2">Nomor BPB:</span>
                      <span>{{ bpbData.bpb_number || 'BPB-202507-00990' }}</span>
                    </div>
                    <div class="d-flex align-center">
                      <span class="font-weight-bold mr-2">Nomor SO:</span>
                      <span>{{ bpbData.order_number || 'SO-202507-00948' }}</span>
                    </div>
                  </div>

                  <!-- Tabel data terkait -->
                  <div class="mb-4">
                    <p class="body-1 mb-3">
                      Data terkait dengan Nomor SO <strong>{{ bpbData.order_number || 'SO-202507-00948' }}</strong>:
                    </p>
                    
                    <!-- Tabel dengan format spreadsheet -->
                    <div class="spreadsheet-table">
                      <table class="confirmation-table">
                        <thead>
                          <tr>
                            <th>Nomor BPB</th>
                            <th>Waktu input BPB</th>
                            <th>Nomor SO</th>
                            <th>Waktu Input SO</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in relatedData" :key="index">
                            <td>{{ item.bpb_number }}</td>
                            <td>{{ item.bpb_input_time }}</td>
                            <td>{{ item.so_number }}</td>
                            <td>{{ item.so_input_time }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Peringatan -->
                  <div class="mb-4">
                    <p class="body-1">
                      Semua BPB terkait SO Nomor <strong>{{ bpbData.order_number || 'SO-202507-00948' }}</strong> akan dihapus
                    </p>
                  </div>

                  <!-- Pertanyaan konfirmasi -->
                  <div class="mb-4">
                    <p class="body-1 font-weight-bold">
                      Anda yakin ingin menghapus data di atas?
                    </p>
                  </div>

                  <!-- Error message -->
                  <div v-if="message.error.length > 0" class="text-center mt-4">
                    <div class="error--text d-flex align-start">
                      <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                      <span class="ml-1">{{ message.error }}</span>
                    </div>
                  </div>
                </div>
              </v-card-text>
              
              <v-divider class="mt-2" style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions class="pa-4">
                <v-spacer/>

                <!-- Tombol Ya, Hapus Data -->
                <v-btn
                  @click="confirmDelete()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  width="180"
                  height="45"
                  elevation="0"
                  color="red"
                  class="fs-16 white--text text-capitalize border-radius mr-3">
                  Ya, Hapus Data
                </v-btn>

                <!-- Tombol Tidak, Batal Hapus Data -->
                <v-btn
                  @click="dialog.confirm = false"
                  :disabled="process.delete"
                  width="200"
                  height="45"
                  outlined
                  elevation="0"
                  color="blue"
                  class="fs-16 blue--text text-capitalize border-radius">
                  Tidak, Batal Hapus Data
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
  
          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Hapus Data
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
  
                <div v-if="message.error.length > 0"
                  class="text-center mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, Hapus
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <section>
            <v-card 
              flat
              class="ma-4 mt-0 box-shadow pb-5"
              style="border-radius: 10px;">
  
              <v-row
                class="pa-4 py-0">
                <v-col
                  cols="12"
                  md="7">
                  <span
                    class="fs-16 black--text mt-1"
                    style="font-weight: 600;">
                    Data BPB Belum Punya Surat Jalan
                  </span>
                  <!-- <div
                    class="body-2">
                    Perbandingan SP2D 
  
                    <span v-if="filter.year !== '' && filter.year !== null">
                      tahun <strong class="black--text">{{ filter.year }}</strong>
                    </span>
  
                    <span v-if="filter.month !== '' && filter.month !== null">
                      di bulan <strong class="black--text">{{ filter.month_text }}</strong>
                    </span>
                  </div> -->
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  class="d-flex align-center pt-1">

                  <v-text-field
                    @click:clear="bpb_number = ''; fetch();"
                    v-on:keyup.enter="fetch()"
  
                    filled
                    rounded
                    dense
                    single-line
  
                    hide-details
                    :color="set_color"
                    placeholder="Cari Dari No BPB"
                    append-icon="mdi-magnify"
                    clearable
  
                    v-model="bpb_number"
                    class="fs-12 little-placeholder"
                    style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                  </v-text-field>

                  <v-text-field
                    @click:clear="order_number = ''; fetch();"
                    v-on:keyup.enter="fetch()"
  
                    filled
                    rounded
                    dense
                    single-line
  
                    hide-details
                    :color="set_color"
                    placeholder="Cari Dari No Order"
                    append-icon="mdi-magnify"
                    clearable
  
                    v-model="order_number"
                    class="ml-3 fs-12 little-placeholder"
                    style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                  </v-text-field>
  
                  <div v-if="!process.load" class="ml-3 black--text">
                    Total data: <strong>{{ pagination.total_data | number }}</strong>
                  </div>
  
                  <!-- FREEZE COLUMN -->
                  <!-- <div class="ml-3">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          elevation="0"
                          outlined
                          dark
                          min-width="36"
                          color="#7B7B7B"
                          class="text-capitalize px-0"
                          style="border-radius: 10px;"
                          v-bind="attrs"
                          v-on="on"
                          @click="dialog.freeze = true">
                          <v-icon size="18">mdi-table-split-cell</v-icon>
                        </v-btn>
                      </template>
  
                      <span>
                        Freeze
                      </span>
                    </v-tooltip>
                  </div> -->
  
                  <!-- HIDE COLUMN -->
                  <!-- <div class="ml-3">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          elevation="0"
                          outlined
                          dark
                          min-width="36"
                          color="#7B7B7B"
                          class="text-capitalize px-0"
                          style="border-radius: 10px;"
                          v-bind="attrs"
                          v-on="on"
                          @click="dialog.hide = true">
                          <v-icon size="18">mdi-eye-off-outline</v-icon>
                        </v-btn>
                      </template>
  
                      <span>
                        Hide
                      </span>
                    </v-tooltip>
                  </div> -->
                </v-col>
              </v-row>
  
              <v-card 
                flat
                class="mt-0 mx-5"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <!-- :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '148px'})`" -->
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                        
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          NO. BPB
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Waktu Input BPB
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          No. SO
                        </th>
                        <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Waktu Input SO
                        </th>
                        <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                        <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                        <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :to="`/hapus-data/bpb/${item.bpb_number}`"
  
                                v-bind="attrs"
                                v-on="on"
  
                                min-width="28"
                                small
                                rounded
                                color="red"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </template>
                            
                            <span>Hapus</span>
                          </v-tooltip>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.bpb_number }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 200px; min-width: 200px; text-align: left;">
                          {{ item.input_datetime | datetime }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          {{ item.order_number }}
                        </td> 
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 200px; min-width: 200px; text-align: left;">{{ item.order_input_datetime | datetime }}</td>
                        <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                        <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                          {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                          {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                        </td> -->
                      </tr>
                    </table>
                  </div>
  
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
  
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
  
                  <v-card-text
                    v-if="list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                        <!-- <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template> -->
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>
  
                  <pagination v-if="!process.load && pagination.total_data > 0"
                    @changePage="fetch($event)" 
                    @reloadPage="fetch($event)" 
                    :model="pagination" :display="paginationList"/>
  
                </div>
  
  
                <!-- <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/> -->
              </v-card>
            </v-card>
  
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          checkbox: false,
          tabs: 0,
          tab: [
            {
              title: 'Belum Diproses',
              id: '0'
            },
            {
              title: 'Sudah Diproses',
              id: '1'
            }
          ],
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            filter: false,
  
            form: false,
            delete: false,
            confirm: false
          },
          
          order_number: '',
          bpb_number: '',
  
          filter: {
            year: new Date().getFullYear()
          },
          sortBy: 'id',
          sortDesc: '-',
  
          selected: {
            freeze: [],
            delete: [],
            row: [],
            export: ''
          },
  
          sales: [],
          salesAll: [],
          supervisor: [],
          filterDataSupervisor: '',
          filterDataSales: '',
  
          form: {
            id: '',
            sales_id: '',
            name_alias: '',
            name: '',
            mobilephone: '',
            address: '',
            pic_name: '',
            email: '',
            nik: '',
            npwp: '',
            plafon: '',
            faktur: '',
            term: '',
            ttd: ''
          },
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
          paginationList: {
            row: 50,
            page: 1
          },
  
          lastIndex: 0,
          limit: 50,
  
          process: {
            load: false,
  
            delete: false,
            export: false,
            form: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      },
      watch: {
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          return this.$store.state.user
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        years () {
          let max = new Date().getFullYear()+2, min = max - 2, years = []
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        }
      },
      mounted () {
        // this.fetchSupervisor()
        // this.fetchSales()
        this.fetch()
      },
      methods: {
        async fetchSales () {
          this.process.load = true
  
          let params = {
            'category_user_id[eq]': '8',
            limit: 1000000,
            is_active: 'Aktif',
            spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : '',
            // limit: 1000000,
            // par_id: '1'
          }
  
          await get(`admin/user/data`, { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.sales = res.results.data
              this.salesAll = res.results.data
              if(this.filterDataSupervisor !== '' && this.filterDataSupervisor !== null && this.filterDataSupervisor !== undefined) {
                this.sales = this.salesAll.filter(sales => sales.spv_id === this.filterDataSupervisor)
              }
            }
            this.process.load = false
          })
        },
        async fetchSupervisor () {
          // this.process.load = true
  
          let params = {
            'category_user_id[eq]': '5',
            limit: 1000000,
            is_active: 'Aktif',
            // limit: 1000000,
            // par_id: '1'
          }
  
          await get(`admin/user/data`, { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.supervisor = res.results.data
              
            }
            // this.process.load = false
          })
        },
        toSort(name) {
          this.sortBy = name
          this.sortDesc = ''
          this.fetch()
        },
        toDesc() {
          this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
          this.fetch()
        },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = value
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            // let regex = /(<([^>]+)>)/ig
  
            // data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
  
        async fetch (pagination = { row: 50, page: 1 }) {
          this.process.load = true
  
          this.limit = pagination.row
          this.paginationList = pagination
  
          let params = {
            limit: pagination.row,
            page: pagination.page,
            // sort: `${this.sortDesc}${this.sortBy}`,
            // spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filterDataSupervisor,
            // sales_name: this.filterDataSales,
            // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            'order_number[lse]': this.order_number,
            'bpb_number[lse]': this.bpb_number,
            // spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filterDataSupervisor,
            // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
          }
  
          this.selected.row = []
  
          // admin/services/data
          
          await get(`admin/delete_data/bpb/data_bpb_tanpa_sj`, { params })
          .then(response => {
            let res = response.data
            
            this.process.load = false
            
            this.list = []
            this.pagination = {}
            
            if (res.status === 200) {
              this.headers = [
                {
                  text: '',
                  width: '120px',
                  value: 'id',
                  freeze: true,
                  hide: false,
                  align: 'start',
                  format: 'action'
                },
                {
                  text: 'No',
                  width: '80',
                  value: 'index',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'No. BPB',
                  width: '200px',
                  value: 'number',
                  freeze: true,
                  hide: false
                },
                {
                  text: 'Alamat',
                  width: '150px',
                  value: 'customer_shipping_province',
                  freeze: false,
                  hide: false,
                  format: 'regex'
                },
                {
                  text: 'No. Order',
                  width: '180px',
                  value: 'order_number',
                  freeze: false,
                  hide: false
                }
              
              ]
      
              this.list = res.results.data
              this.pagination = res.results.pagination
  
              // this.list.map(obj => {
              //   obj.is_active = obj.is_active === 'Aktif' ? true : false
              // })
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
  
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },
  
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = '#e0e0e0'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
  
        reset (index) {
          if (this.$refs.form) this.$refs.form.reset()
          
          this.form = {
            id: index !== undefined ? this.list[index].id : '',
            name: index !== undefined ? this.list[index].name : '',
            address: index !== undefined ? this.list[index].address : '',
            mobilephone: index !== undefined ? this.list[index].mobilephone : "",
            pic_name: index !== undefined ? this.list[index].pic_name : "",
            email: index !== undefined ? this.list[index].email : "",
            nik: index !== undefined ? this.list[index].nik : "",
            npwp: index !== undefined ? this.list[index].npwp : "",
            // is_active: index !== undefined ? this.list[index].is_active === 'Aktif'? 1 : 0 : 1
          }
  
          this.process.form = false
  
          this.message.error = ''
        },
  
        updateStatus (item) {
          this.selected.row = [item]
  
          this.dialog.form = true
        },
  
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
  
          if (isValid) {
            this.process.form = true
  
            let url = this.form.id === '' ? 'admin/customer/add' : 'admin/customer/update'
  
            // SAVE TO REST API
            await post(url, {
              data: this.form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
                this.dialog.form = false
  
                this.dialog.snackbar = true
                this.message.success = res.message
  
                this.dialog.fullscreen = false
  
                this.reset()
  
                this.fetch()
              } else {
                this.message.error = res.message
              }
            })
  
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
  
        toDelete (id) {
          this.selected.delete = [id]
  
          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''
  
          this.process.delete = true
  
          await post(`admin/bpb/delete`, {
            data: {
              id: this.selected.delete[0]
            }
          }).then(response => {
            let res = response.data
  
            this.process.delete = false
  
            if (res.status === 200) {
  
              this.dialog.delete = false
  
              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        },
  
        async exports (id) {
          this.message.error = ''
  
          this.process.export = true
  
          let params = {
            bpb_id: id
          }
  
          await axios({
            url: `${process.env.VUE_APP_API_URL}admin/bpb/export_pdf`,
            method: 'GET',
            responseType: 'blob', // important,
            params: params,
            headers: {
              Authorization: process.env.VUE_APP_XAUTH,
              token: TokenService.getToken()
            }
          }).then((response) => {
            let res = response
  
            this.process.export = false
            console.log(res.headers)
            let disposition = res.headers['content-disposition']
            // console.log(disposition)
            var fileName = res.headers['content-disposition'].split('filename=\"')[1]
            let filename = ''
  
            if (disposition && disposition.indexOf('inline') !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) { 
                filename = matches[1].replace(/['"]/g, '');
              }
            }
            // console.log(filename)
  
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = 'Berhasil mengeksport pdf'
  
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement('a')
              link.href = url
  
              link.setAttribute('download', filename)
              document.body.appendChild(link)
  
              link.click()
            } else {
              this.message.error = res.message
            }
          })
        }
  
      }
    }
  </script>
  
  <style>
    /* ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    } */
    ::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background-color: #718EBF;
    }
    table, th, td {
      /* border: 1px solid #ededed;
      border-collapse: collapse; */
      /* border: thin ridge black; */
      border-spacing: 4px;
      border-collapse: collapse;
    }
  
    .view {
      margin: auto;
      /* width: 100%; */
    }
  
    .wrapper { 
      overflow-y: auto; 
      height: calc(100vh - 280px); 
    } 
  
    .wrapper-none { 
      /* overflow-y: auto; 
      height: calc(100vh - 270px);  */
    } 
  
    .wrapper th { 
      position: sticky; 
      top: 0; 
      background-color: white !important;
    } 
    .sticky-col {
      position: -webkit-sticky;
      position: sticky;
      background-color: white !important;
    }
  
    .one-col {
      width: 60px;
      min-width: 60px;
      max-width: 60px;
      left: 0px;
    }
  
    .second-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 150px;
    }
  
    .three-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 300px;
    }
  
    .four-col {
      width: 200px;
      min-width: 200px;
      max-width: 200px;
      left: 450px;
    }
  
    tr:hover {background-color: #1976d236;}
    tr.selected {background-color: #1976d236;}
  </style>